import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { ThemeContextProvider } from "./context/theme/theme-context";
import { GlobalStyle } from "./global-style/global-style";
import App from "./App";
import { IsMobileProvider } from "./context/mobile/is-mobile-context";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 10,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const persister = createAsyncStoragePersister({ storage: window.localStorage });
persistQueryClient({ queryClient, persister });

createRoot(document.getElementById("root")!).render(
  <ThemeContextProvider>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <IsMobileProvider>
          <GlobalStyle />
          <App />
        </IsMobileProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </ThemeContextProvider>
);
